// sort predicates for strings
export function stringCompareKey(key) {
  return (a, b) => `${a[key] || ''}`.localeCompare(b[key] || '')
}

// sort predicates for dates
export function dateCompare(a, b) {
  const timeA = Math.floor(new Date(a.timeStamp) / 1000)
  const timeB = Math.floor(new Date(b.timeStamp) / 1000)
  return timeA - timeB
}
